var React = require('react');

function RightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.54739 11L7 5.5L1.54739 0L0 1.56084L3.90636 5.5L0 9.43916L1.54739 11Z","fill":"#404043"}));
}

RightInline.defaultProps = {"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none"};

module.exports = RightInline;

RightInline.default = RightInline;
